import type { LanguageConfig } from '../types'

export const LANGUAGES: LanguageConfig[] = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇬🇧',
    countryCode: 'GB'
  },
  {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    flag: '🇪🇸',
    countryCode: 'ES'
  },
  {
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    flag: '🇫🇷',
    countryCode: 'FR'
  },
  {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
    flag: '🇩🇪',
    countryCode: 'DE'
  },
  {
    code: 'it',
    name: 'Italian',
    nativeName: 'Italiano',
    flag: '🇮🇹',
    countryCode: 'IT'
  },
  {
    code: 'pt',
    name: 'Brazilian Portuguese',
    nativeName: 'Português (Brasil)',
    flag: '🇧🇷',
    countryCode: 'BR'
  },
  {
    code: 'el',
    name: 'Greek',
    nativeName: 'Ελληνικά',
    flag: '🇬🇷',
    countryCode: 'GR'
  },
  {
    code: 'zh',
    name: 'Chinese',
    nativeName: '中文',
    flag: '🇨🇳',
    countryCode: 'CN'
  },
  {
    code: 'ja',
    name: 'Japanese',
    nativeName: '日本語',
    flag: '🇯🇵',
    countryCode: 'JP'
  },
  {
    code: 'ko',
    name: 'Korean',
    nativeName: '한국어',
    flag: '🇰🇷',
    countryCode: 'KR'
  }
]

export const SUPPORTED_LANGUAGES = LANGUAGES.map((lang) => lang.code)

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: LanguageCode = 'en'
